import script from "./TariffProView.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffProView.vue?vue&type=script&setup=true&lang=js"

import "./TariffProView.vue?vue&type=style&index=0&id=70c2a43c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c2a43c"]])

export default __exports__